document.addEventListener("DOMContentLoaded", function() {
  var carouselContainerMen = document.querySelector('.product-carousel__container__men');
  var prevButtonMen = document.querySelector('.product-carousel__prev__men');
  var nextButtonMen = document.querySelector('.product-carousel__next__men');

  if (prevButtonMen && nextButtonMen && carouselContainerMen) {
    prevButtonMen.addEventListener('click', function() {
      if (carouselContainerMen.scrollLeft > 0) {
      carouselContainerMen.scrollBy({
        left: -carouselContainerMen.clientWidth,
        behavior: 'smooth'
      });
      }
    });
  
    nextButtonMen.addEventListener('click', function() {
      // Check if we're at the last scrollable position
      var maxScrollLeft = carouselContainerMen.scrollWidth - carouselContainerMen.clientWidth;
      if (carouselContainerMen.scrollLeft < maxScrollLeft) {
      carouselContainerMen.scrollBy({
        left: carouselContainerMen.clientWidth,
        behavior: 'smooth'
      });
      }
    });
  }
  
  var carouselContainerWomen = document.querySelector('.product-carousel__container__women');
  var prevButtonWomen = document.querySelector('.product-carousel__prev__women');
  var nextButtonWomen = document.querySelector('.product-carousel__next__women');

  if (prevButtonWomen && nextButtonWomen && carouselContainerWomen) {
    prevButtonWomen.addEventListener('click', function() {
      if (carouselContainerWomen.scrollLeft > 0) {
      carouselContainerWomen.scrollBy({
        left: -carouselContainerWomen.clientWidth,
        behavior: 'smooth'
      });
      }
    });
  
    nextButtonWomen.addEventListener('click', function() {
      // Check if we're at the last scrollable position
      var maxScrollLeft = carouselContainerWomen.scrollWidth - carouselContainerWomen.clientWidth;
      if (carouselContainerWomen.scrollLeft < maxScrollLeft) {
      carouselContainerWomen.scrollBy({
        left: carouselContainerWomen.clientWidth,
        behavior: 'smooth'
      });
      }
    });
  }
});
